




















































































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { openEdit, openSelectList } from '@/main/router/routerPath';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { NAME as ZAPUJCKY_NAME } from '@/modules/pujcovna/zapujcka/constants';
import { NAME as ZAKAZKA_NAME, ZAKAZKA_DRUH_LOCALIZED } from '@/modules/servis/zakazka/constants';
import { PageMode } from '@/main/utils/pageMode';

import { NAME } from './constants';
import { editActions, editMutations } from './store/types';
import { store, PujckaRow } from './store/edit';
import ProvozovnaSelect from '../components/microcomponents/ProvozovnaSelect.vue';

export default editFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		SkladMistoSelect: SkladMisto.components.Select,
		ProvozovnaSelect,
	},
	data() {
		return {
			visible: false,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${editMutations.ZAPUJCKY_PRACOVNIK_SELECT_MAPPER}`,
			};
		},
		pujckaFilter(): object {
			return {
				PujcovnapaNr: this.props.PujcovnapaNr,
				ZakazkaId: this.filterByZakazka ? this.ZakazkaId : null,
				ZakaznikId: this.filterByZakaznik ? this.props.ZakaznikId : null,
				VracenoPrp: true,
				VlastnivozPrp: true,
				ExternivozPrp: true,
				NajemnivozPrp: true,
				VpripravePrp: false,
			};
		},
		isPujcovnaBtnDisabled(): boolean {
			return (!this.isCreateMode || (this.PujcovnapaId !== null && this.PujcovnapaId > 0)) || this.props.PujcvnaCreateZakazka;
		},
		isPujcovnaIdDisabled(): boolean {
			return !this.isCreateMode;
		},
		strednaklOznDropdown(): any {
			return _.filter(this.dropdownList.StredNaklOzn, { ProvozovnaId: Number(this.ProvozovnaId) });
		},
	},
	methods: {
		loadedData() {
			if (this.props.PujcvnaCreateZakazka) {
				this.props.PujcvnaCreateZakazka = false;
				this.filterByZakazka = false;
				this.filterByZakaznik = false;
				this.$nextTick(() => { this.onPujcovnaButtonClick(); });
			}
		},
		onPujcovnaChange(val: number) {
			this.Text = null;
			this.Pc = null;
			this.DphSzbOzn = null;
			this.Sleva = null;
			this.PcPevna = null;
			this.PujcovnapaId = null;
			this.PujcovnaId = val;
		},

		onPujcovnaButtonClick() {
			openSelectList(ZAPUJCKY_NAME, {
				afterRowSelection: this.onZapujckaSelect,
				filter: this.pujckaFilter,
				isFilterVisible: false,
			});
		},
		async onZapujckaSelect({ row }: { row: PujckaRow }) {
			this.startLoadingV2();
			if (!(await this.checkZakaznikAndConfirm(row))) return;
			const params = {
				PujcovnapaId: row.PUJCOVNAPA_ID,
				ZakazkaId: this.ZakazkaId,
			};
			const resp = await this[editActions.KONTROLA_ZAPUJCKY](params);
			if (await this.checkZakazkaAndConfirm(resp)) {
				await openEdit(ZAKAZKA_NAME, PageMode.EDIT, { id: resp.data.ZakazkaId });
			}
			this.endLoadingV2();
		},

		async checkZakaznikAndConfirm({ ZAKAZNIK_ID, X_FIRM_PRIJM }: PujckaRow): Promise<boolean> {
			if (ZAKAZNIK_ID !== Number(this.props.ZakaznikId)) {
				const message = `${this.LocalizeChyboveHlasky('ZakazkapaJinyZak')} <b>${X_FIRM_PRIJM}</b></br>
											 </br>
											 ${this.LocalizeChyboveHlasky('ZakazkapaOdepsat')}`;
				return this.showConfirmPokracovat(message, true, true);
			}
			return true;
		},

		async checkZakazkaAndConfirm(response: { data: { ZakazkaId: any, ZakazkaDruh: any, ZakazkaNr: any } }): Promise<boolean> {
			if (response.data.ZakazkaId > 0) {
				const druh = this.LocalizePopisostatni((ZAKAZKA_DRUH_LOCALIZED as Record<string, string>)[response.data.ZakazkaDruh]);
				const msg = `${this.LocalizeChyboveHlasky('ZakazkapaJinaZak')} ${druh} ${response.data.ZakazkaNr}. </br>
				${this.LocalizeChyboveHlasky('OtevritZakazku')}?`;
				return this.showConfirmPokracovat(msg, true, true);
			}
			return false;
		},
	},
});
